import React from 'react'
import countryCodesLib from '../../libs/countryCodes'
import { translateMetaError } from '../../libs/metaErrors'

// Peças comuns aos envios de teste da tela "Enviar mensagem": o "Teste antes
// no seu número" do disparo e o texto livre de teste da API Oficial. Os dois
// pedem número com país + DDD e precisam ler a resposta do servidor do mesmo
// jeito — inclusive quando a mensagem fica retida por saldo, que volta como
// "sucesso" mas não sai.

export const BRASIL = countryCodesLib.codes.find((pais) => pais.code === 'BR')

export const digitosDe = (valor) => String(valor || '').replace(/\D/g, '')

// Número completo como o servidor espera (só dígitos, com o código do país).
export const telefoneDe = (pais, digitado) => `${digitosDe(pais.dial_code)}${digitosDe(digitado)}`

// Como mostramos para a pessoa: "+55 51999999999".
export const exibidoDe = (pais, digitado) => `${pais.dial_code} ${digitosDe(digitado)}`

// Menos que isso não chega a ser DDD + número em país nenhum.
export const numeroCompleto = (digitado) => digitosDe(digitado).length >= 8

// Mesma frase do recibo do disparo: sem saldo a mensagem não é recusada, ela
// espera. No teste isso vale até para o texto livre, que não custa nada — a
// trava de saldo é da conexão, não da mensagem.
export const TEXTO_RETIDA_POR_SALDO = 'Sem saldo na conexão: o teste fica retido até a recarga, mesmo sem custo.'

// Lê a resposta 2xx do envio. O servidor responde 200 também quando a
// mensagem ficou retida (por saldo ou pelo SmartFilter); só "message_queued"
// é envio de fato.
export function resultadoDoEnvio(resposta) {
  const situacao = resposta?.status_result
  if (!situacao || situacao === 'message_queued') return { estado: 'ok' }
  if (situacao === 'message_held_insufficient_balance') return { estado: 'retida', texto: TEXTO_RETIDA_POR_SALDO }
  return { estado: 'retida', texto: resposta?.message || 'A mensagem ficou retida e não saiu agora.' }
}

// Erro do envio em português claro. Conexão inativa/suspensa e saldo ganham
// frase própria; o resto mostra o que o servidor disse.
export function mensagemDoErro(e) {
  const dados = e?.response?.data || {}
  const texto = String(dados.error || dados.message || '')
  if (texto === 'QR CODE NÃO ESCANEADO') return 'Conecte o WhatsApp pelo QR Code antes de testar.'
  if (/n[ãa]o est[áa] ativa|suspens/i.test(texto)) return 'Conexão inativa ou suspensa: nem o teste sai enquanto ela não for reativada.'
  if (/saldo/i.test(texto)) return TEXTO_RETIDA_POR_SALDO
  // Recusa da Meta que já voltou na hora (ex.: 131047, fora da janela de 24h):
  // a mesma explicação que o Relatório mostra.
  const daMeta = (dados.code || texto) ? translateMetaError({ code: dados.code, text: texto }) : null
  if (daMeta && !daMeta.generica) return daMeta.explicacao
  return texto || 'Não foi possível enviar o teste agora.'
}

// Botão do país + campo do número, no mesmo visual do disparo.
export function CampoDeNumero({ pais, onEscolherPais, valor, onValor, rotulo, placeholder = '51 99999 9999', disabled }) {
  return (
    <>
      <button
        type="button"
        className="dp-pais"
        onClick={onEscolherPais}
        aria-label={`País ${pais.dial_code}${rotulo ? ` (${rotulo})` : ''}`}
        disabled={disabled}
      >
        <span>{pais.flag}</span><span>{pais.dial_code}</span>
      </button>
      <input
        className="dp-campo"
        aria-label={rotulo}
        placeholder={placeholder}
        inputMode="tel"
        value={valor}
        disabled={disabled}
        onChange={(e) => onValor(e.target.value)}
      />
    </>
  )
}
